import { flow, types } from "mobx-state-tree"
import Api from '../api/Api'
import State, {pending, error, done, notLoaded} from './State'

const InventoryLocationStore = types.model({
    inventoryLocations: types.frozen(),
    inventoryLocationsState: types.optional(State, notLoaded),
    inventoryLocation: types.frozen(),
    inventoryLocationState: types.optional(State, notLoaded),
})
.actions(self => ({
    fetchAccountInventoryLocations: flow(function* fetchAccountInventoryLocations(accountId, rowsPerPage, page) {
        self.inventoryLocations = undefined
        self.inventoryLocationsState = pending
        try {
            let url = `/inventory_locations/?customer__account=${accountId}`;
            if (rowsPerPage && page) {
                url = `${url}&limit=${rowsPerPage}&offset=${page*rowsPerPage}`
            }
            const response = yield Api.get(url)
            self.inventoryLocations = response.data
            self.inventoryLocationsState = done
        } catch (e) {
            console.error(e)
            self.inventoryLocationsState = error
        }
    }),
    fetchCustomerInventoryLocations: flow(function* fetchCustomerInventoryLocations(customerId) {
        self.inventoryLocations = undefined
        self.inventoryLocationsState = pending
        try {
            const response = yield Api.get(`/inventory_locations/?customer=${customerId}`)
            self.inventoryLocations = response.data
            self.inventoryLocationsState = done
        } catch (e) {
            console.error(e)
            self.inventoryLocationsState = error
        }
    }),
    fetchInventoryLocation: flow(function* fetchInventoryLocation(id) {
        self.inventoryLocation = undefined;
        self.inventoryLocationState = pending
        try {
            const response = yield Api.get(`/inventory_locations/${id}/`)
            self.inventoryLocation = response.data
            self.inventoryLocationState = done
        } catch (e) {
            console.error(e)
            self.inventoryLocationState = error
        }
    }),
}))

export default InventoryLocationStore.create({})


// WEBPACK FOOTER //
// ./src/stores/InventoryLocationStore.js